import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { DeviceTask } from '@rocksoft/device-task-management-sdk';

export type DeviceScheduledTasksState = EntityState<DeviceTask>;

export function selectScheduledTaskId(scheduledTask: DeviceTask): string {
  return scheduledTask.messageId ?? ''; // TODO: figure out a better way to uniquely identify a scheduled task, as messageId is not guaranteed to be unique
}

export const adapter: EntityAdapter<DeviceTask> = createEntityAdapter<DeviceTask>({
  selectId: selectScheduledTaskId,
});

export const initialState: DeviceScheduledTasksState = adapter.getInitialState();
